export const encodeToBase64 = (string: string) => {
  let result;
  try {
    result = btoa(string);
  } catch (e) {
    result = btoa(encodeURIComponent(string));
  }
  return result;
};
